import { useEffect } from "react";
import CooperationMode from "../../AllServices/Cooperation-model/coopModel";
import QuickNav from "../../HomePage/HeroSection/QuickNav";
import OfferingProjectManagerServicePage from "../../Offering-PM-servicePage/Offering-PmService";
import PopupModal from "../../PopUp/popup-modal";
import { HireBanner } from "../DevForHire/DevForHireBanner/HireBanner";
import { DevOffer } from "../DevForHire/DevOffer/DevOffer";
import { HiringProcedure } from "../DevForHire/HiringProcedure/HiringProcedure";
import ArchitectureCodeSample from "./Architecture/ArchitectureCodeSample";
import DevForHireFAQ from "../DevForHire/DevForHireFAQ/DevForHireFAQ";
import { Helmet } from "react-helmet-async";

const DevelopersForHire = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const QuickNavItems = [
    "Services",
    "Hire Process",
    "Code Quality",
    "Approach",
    "Samples",
    "Hiring Model",
    "F&Q",
  ];
  return (
    <div>
      <>
        <Helmet>
          <title>Hire Dedicated Developers in Bangladesh | Quad Theory Ltd</title>
          <meta
            name="description"
            content="Hire dedicated developers in Bangladesh with Quad Theory Ltd. Solo developers or full teams, clear communication, and flexible hiring models that fit how real products are built."
          />
        </Helmet>
      </>
      <HireBanner />
      <QuickNav items={QuickNavItems} />
      <DevOffer />
      <HiringProcedure />
      <PopupModal />
      <OfferingProjectManagerServicePage />
      <ArchitectureCodeSample />
      <CooperationMode />
      <DevForHireFAQ />
    </div>
  );
};

export default DevelopersForHire;
